import { IconPropsType } from '..';

export const SupportIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="general=notification, betting=default, statuses=default, arrows=default, toggleables=default, signs=default, menus=default, casino=default, currency=default">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.00001 8C1.00001 5 2.00001 4 5.00001 4H15C18 4 19 5 19 8V12C19 15 18 16 15 16H5.00001L1.00001 18V14L1 14L1.00001 10V8ZM8.5 12H11.5V8H8.5V12ZM16 12H13V8H16V12ZM4 12H7.00001V8H4V12Z"
        />
      </g>
    </svg>
  );
};
